import { Modal, App } from 'antd';
import React from 'react'
import { useGoodsDelMutation } from '../../store/ReactWebSiteApi';

function GoodsDel(props) {
    const { message } = App.useApp();
    const {confirm} = Modal; 
    const [submitDel] = useGoodsDelMutation()
    return (
        <>
            {props.eg_state==='2'&&<a onClick={() => {
                            confirm({
                                title: '确定删除吗？',
                                content: props.eg_name,
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk() {
                                    submitDel({
                                        eg_id:props.eg_id,
                                        eg_state:'2'
                                    }).then((res) => {
                                        console.log(res);
                                        if (res.data.Status === 'success') {
                                            message.info('删除成功！');
                                        }
                                        if (res.data.Status === "fail") {
                                            message.error('删除失败！'+res.data.Message)
                                        }
                                    })
                                },
                                onCancel() {
                                console.log('Cancel');
                                },
                            });
                        }}>删除</a>}
             {props.eg_state==='1'&&<a onClick={() => {
                            confirm({
                                title: '确定取消删除吗？',
                                content: props.eg_name,
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk() {
                                    submitDel({
                                        eg_id:props.eg_id,
                                        eg_state:'1'
                                    }).then((res) => {
                                        console.log(res);
                                        if (res.data.Status === 'success') {
                                            message.info('取消删除成功！');
                                        }
                                        if (res.data.Status === "fail") {
                                            message.error('取消删除失败！'+res.data.Message)
                                        }
                                    })
                                },
                                onCancel() {
                                console.log('Cancel');
                                },
                            });
                        }}>取消删除</a>}
        </>
    )
}

export default GoodsDel